import React, { Children, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { REQ_ERROR, VALID_ERROR } from 'constants/Constants';

import { usePageMessages } from 'hooks/selectors';

import PromoFieldLongTitlePopup from './PromoFieldLongTitlePopup';
import { FloatingLabel, HintButton, HintContainer, InputContainer, InputLabel, InputRightElement } from './styles';
import { LightDiskButton } from '../common/fromAuth/LightDiskButton/LightDiskButton';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { PromoIcon } from '../common/promo-icon/PromoIcon';
import PromoPopup from '../popup/PromoPopup';

const PromoInputWrapper = ({ isDetached = false, ...props }) => {
    const popupRef = useRef(null);

    const { nameNameFMatching } = usePageMessages();

    const canShowComment = () => {
        return props.comment && !props.isShowCustomComment && !props.isError;
    };

    const canShowCustomComment = () => {
        return nameNameFMatching && props.isShowCustomComment && !props.isError;
    };

    const errorMessage = props.isEmptyValue ? props.reqError : props.regexpErrorMessage ? props.regexpErrorMessage : props.validError;

    const popupComponent = <PromoFieldLongTitlePopup info={props.commentLong} popupRef={popupRef} />;

    return (
        <>
            <InputContainer
                ref={props.forwardedRef}
                isError={props.isError}
                isFilled={props.isFilled}
                isReadOnly={props.isReadOnly}
                isFocused={props.isFocused}
                hasWhiteBg={props.hasWhiteBg}
            >
                <InputLabel htmlFor={props.name} onClick={(e) => props.setFocus(e)} isError={props.isError} isPseudoSelect={props.isPseudoSelect}>
                    {props.leftInputComponent}
                    {Children.count(props.children) > 1 ? props.children[0] : props.children}
                    <FloatingLabel isError={props.isError} isFilled={props.isFilled} isReadOnly={props.isReadOnly} isFocused={props.isFocused}>
                        {props.labelText}
                    </FloatingLabel>
                </InputLabel>
                {props.isPseudoSelect && (
                    <InputRightElement>
                        <PromoIcon name="chevron-down" size={'24px'} />
                    </InputRightElement>
                )}
                {props.commentLong && (
                    <InputRightElement isInfoButtonForPseudoselect={props.isPseudoSelect && props.commentLong}>
                        <LightDiskButton
                            size="small"
                            type="button"
                            variant="tertiary"
                            iconName="info-rounded"
                            iconColor="mediumGray"
                            raised={false}
                            onClick={() => popupRef.current?.open(popupComponent)}
                        />
                    </InputRightElement>
                )}
                {props.children &&
                    Children.count(props.children) > 1 &&
                    props.children.map((children, index) => {
                        if (index !== 0) {
                            return children;
                        }
                    })}
            </InputContainer>
            {canShowComment() && (
                <HintContainer>
                    <LightText variant="div" color="mediumGray" size="secondary">
                        {props.comment}
                        {props.commentLong && (
                            <HintButton>
                                <LightDiskButton
                                    size="small"
                                    type="button"
                                    iconName="info-rounded"
                                    iconColor="mediumGray"
                                    raised={false}
                                    onClick={() => popupRef.current?.open(popupComponent)}
                                />
                            </HintButton>
                        )}
                    </LightText>
                </HintContainer>
            )}
            {canShowCustomComment() && (
                <HintContainer>
                    <LightText variant="div" color="mediumGray" size="secondary">
                        {nameNameFMatching}
                    </LightText>
                </HintContainer>
            )}
            {props.isError && !isDetached && (
                <HintContainer>
                    <LightText variant="div" color="red" size="secondary">
                        {props.errorMessage || errorMessage}
                    </LightText>
                </HintContainer>
            )}
            <PromoPopup ref={popupRef} />
        </>
    );
};

PromoInputWrapper.propTypes = {
    errorMessage: PropTypes.string,
    name: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    labelText: PropTypes.string,
    isFilled: PropTypes.bool,
    isError: PropTypes.bool,
    isFocused: PropTypes.bool,
    leftInputComponent: PropTypes.object,
    hintButtonClick: PropTypes.func,
    comment: PropTypes.string,
    commentLong: PropTypes.string,
    isPseudoSelect: PropTypes.bool,
    hasWhiteBg: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        validError: state.messages.jsMessages[VALID_ERROR],
        reqError: state.messages.jsMessages[REQ_ERROR],
    };
};

export default connect(mapStateToProps)(PromoInputWrapper);
